import ClearingAPI from '@shared/api';

export const {
    transfers: { getHistory },
} = ClearingAPI.settings;
